import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import SearchBar from "components/commonComponents/searchBar";
import Filters from "components/commonComponents/filter";
import { Tooltip } from "antd";
import { ICONS } from "../../../../../../assets/icons";

const statusFilterOptions = [
  {
    id: 1,
    name: "STATUS",
    subFilter: [
      {
        id: 1,
        label: "Draft",
        value: "DRAFT",
        status: "DRAFT",
      },
      {
        id: 2,
        label: "Deprecated",
        value: "DEPRECATED",
        status: "DEPRECATED",
      },
      {
        id: 3,
        label: "Throttled",
        value: "THROTTLED",
        status: "THROTTLED",
      },
      {
        id: 4,
        label: "Blocked",
        value: "BLOCKED",
        status: "BLOCKED",
      },
      {
        id: 5,
        label: "Published",
        value: "PUBLISHED",
        status: "PUBLISHED",
      },
    ],
  }
];

const FlowListHeader = ({
  inputRef,
  loading,
  searchKey,
  setSearchKey,
  onSearchChange,
  onFilterChange,
  selectedStatus,
  clearAllFilter,
  handleSync,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [syncDisabled, setSyncDisabled] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  // Check localStorage for last sync time on mount
  useEffect(() => {
    const lastSync = localStorage.getItem("flows_sync_last_time");
    if (lastSync) {
      const diff = 60 - Math.floor((Date.now() - Number(lastSync)) / 1000);
      if (diff > 0) {
        setSyncDisabled(true);
        setSecondsLeft(diff);
        const interval = setInterval(() => {
          const newDiff = 60 - Math.floor((Date.now() - Number(lastSync)) / 1000);
          setSecondsLeft(newDiff > 0 ? newDiff : 0);
          if (newDiff <= 0) {
            setSyncDisabled(false);
            clearInterval(interval);
          }
        }, 1000);
        return () => clearInterval(interval);
      }
    }
  }, []);

  // Enhanced handleSync with cooldown
  const handleSyncClick = () => {
    if (syncDisabled) return;
    
    // Call the original handleSync
    if (typeof handleSync === 'function') {
      handleSync();
    }

    // Set cooldown
    localStorage.setItem("flows_sync_last_time", Date.now().toString());
    setSyncDisabled(true);
    setSecondsLeft(60);
    
    // Start countdown
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          setSyncDisabled(false);
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <div className="p-3 bg-white flex flex-row items-center justify-between">
      <div className="flex-1 max-w-md">
        <SearchBar
          
          ref={inputRef}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          onChange={onSearchChange}
          expandable={false}
          placeholder="Search by flow name or ID"
        />
      </div>
      <div className="flex items-center gap-3">
        <div className="flex-row align-center space-between gap-[0.8vw]">
          <Tooltip trigger="hover" title="Sync Flows" placement="top">
            <div
              className={`px-3 py-[0.497vw] rounded-md flex items-center ${
                syncDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
              onClick={handleSyncClick}
            >
              <img
                src={ICONS?.syncRefreshTemplate}
                alt="syncRefresh"
                className={`w-[1vw] h-[1vw] ${syncDisabled ? "animate-spin" : ""}`}
              />
              <span className="text-[0.975rem] text-[#616874] font-[500] pl-2">
                Sync{syncDisabled ? ` (${secondsLeft}s)` : ''}
              </span>
            </div>
          </Tooltip>
        </div>

        <Filters
          options={statusFilterOptions}
          selectedOptions={selectedStatus}
          loading={loading}
          onChange={onFilterChange}
          onClearAll={clearAllFilter}
        />
        <button
          className={`!bg-[var(--new-primary)] text-white px-4 py-1.5 font-medium rounded-md transition-colors ${
            loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[var(--new-primary-dark)]"
          }`}
          onClick={() => {
            if (!loading) {
              navigate("/user/channels/whatsapp/flows/create-flow");
            }
          }}
          disabled={loading}
        >
          Create Flow
        </button>
      </div>
    </div>
  );
};

export default FlowListHeader;